/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as ReservationsRouteImport } from './routes/reservations'
import { Route as ProductsChainsRouteImport } from './routes/products-chains'
import { Route as ProductsRouteImport } from './routes/products'
import { Route as PlannerCalendarRouteImport } from './routes/planner-calendar'
import { Route as PlannerRouteImport } from './routes/planner'
import { Route as LegacyFormRouteImport } from './routes/legacy-form'
import { Route as DesignRouteImport } from './routes/design'
import { Route as ColumbusPlannerRouteImport } from './routes/columbus-planner'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'

const SecurityRoute = SecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => rootRouteImport,
} as any)
const ReservationsRoute = ReservationsRouteImport.update({
  id: '/reservations',
  path: '/reservations',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsChainsRoute = ProductsChainsRouteImport.update({
  id: '/products-chains',
  path: '/products-chains',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsRoute = ProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => rootRouteImport,
} as any)
const PlannerCalendarRoute = PlannerCalendarRouteImport.update({
  id: '/planner-calendar',
  path: '/planner-calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const PlannerRoute = PlannerRouteImport.update({
  id: '/planner',
  path: '/planner',
  getParentRoute: () => rootRouteImport,
} as any)
const LegacyFormRoute = LegacyFormRouteImport.update({
  id: '/legacy-form',
  path: '/legacy-form',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignRoute = DesignRouteImport.update({
  id: '/design',
  path: '/design',
  getParentRoute: () => rootRouteImport,
} as any)
const ColumbusPlannerRoute = ColumbusPlannerRouteImport.update({
  id: '/columbus-planner',
  path: '/columbus-planner',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/columbus-planner': typeof ColumbusPlannerRoute
  '/design': typeof DesignRoute
  '/legacy-form': typeof LegacyFormRoute
  '/planner': typeof PlannerRoute
  '/planner-calendar': typeof PlannerCalendarRoute
  '/products': typeof ProductsRoute
  '/products-chains': typeof ProductsChainsRoute
  '/reservations': typeof ReservationsRoute
  '/security': typeof SecurityRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/columbus-planner': typeof ColumbusPlannerRoute
  '/design': typeof DesignRoute
  '/legacy-form': typeof LegacyFormRoute
  '/planner': typeof PlannerRoute
  '/planner-calendar': typeof PlannerCalendarRoute
  '/products': typeof ProductsRoute
  '/products-chains': typeof ProductsChainsRoute
  '/reservations': typeof ReservationsRoute
  '/security': typeof SecurityRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/columbus-planner': typeof ColumbusPlannerRoute
  '/design': typeof DesignRoute
  '/legacy-form': typeof LegacyFormRoute
  '/planner': typeof PlannerRoute
  '/planner-calendar': typeof PlannerCalendarRoute
  '/products': typeof ProductsRoute
  '/products-chains': typeof ProductsChainsRoute
  '/reservations': typeof ReservationsRoute
  '/security': typeof SecurityRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/columbus-planner'
    | '/design'
    | '/legacy-form'
    | '/planner'
    | '/planner-calendar'
    | '/products'
    | '/products-chains'
    | '/reservations'
    | '/security'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/columbus-planner'
    | '/design'
    | '/legacy-form'
    | '/planner'
    | '/planner-calendar'
    | '/products'
    | '/products-chains'
    | '/reservations'
    | '/security'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/columbus-planner'
    | '/design'
    | '/legacy-form'
    | '/planner'
    | '/planner-calendar'
    | '/products'
    | '/products-chains'
    | '/reservations'
    | '/security'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  ColumbusPlannerRoute: typeof ColumbusPlannerRoute
  DesignRoute: typeof DesignRoute
  LegacyFormRoute: typeof LegacyFormRoute
  PlannerRoute: typeof PlannerRoute
  PlannerCalendarRoute: typeof PlannerCalendarRoute
  ProductsRoute: typeof ProductsRoute
  ProductsChainsRoute: typeof ProductsChainsRoute
  ReservationsRoute: typeof ReservationsRoute
  SecurityRoute: typeof SecurityRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/security': {
      id: '/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof SecurityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reservations': {
      id: '/reservations'
      path: '/reservations'
      fullPath: '/reservations'
      preLoaderRoute: typeof ReservationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products-chains': {
      id: '/products-chains'
      path: '/products-chains'
      fullPath: '/products-chains'
      preLoaderRoute: typeof ProductsChainsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products': {
      id: '/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof ProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/planner-calendar': {
      id: '/planner-calendar'
      path: '/planner-calendar'
      fullPath: '/planner-calendar'
      preLoaderRoute: typeof PlannerCalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/planner': {
      id: '/planner'
      path: '/planner'
      fullPath: '/planner'
      preLoaderRoute: typeof PlannerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legacy-form': {
      id: '/legacy-form'
      path: '/legacy-form'
      fullPath: '/legacy-form'
      preLoaderRoute: typeof LegacyFormRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/design': {
      id: '/design'
      path: '/design'
      fullPath: '/design'
      preLoaderRoute: typeof DesignRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/columbus-planner': {
      id: '/columbus-planner'
      path: '/columbus-planner'
      fullPath: '/columbus-planner'
      preLoaderRoute: typeof ColumbusPlannerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  ColumbusPlannerRoute: ColumbusPlannerRoute,
  DesignRoute: DesignRoute,
  LegacyFormRoute: LegacyFormRoute,
  PlannerRoute: PlannerRoute,
  PlannerCalendarRoute: PlannerCalendarRoute,
  ProductsRoute: ProductsRoute,
  ProductsChainsRoute: ProductsChainsRoute,
  ReservationsRoute: ReservationsRoute,
  SecurityRoute: SecurityRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
